import { Link } from "react-router-dom";
import { useLang } from "@/lib/lang";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-[#00F0FF] to-[#4D00FF] flex items-center justify-center text-black font-black text-sm font-['Unbounded']">F</div>
              <span className="font-['Unbounded'] font-bold text-white text-sm">Fortis Digital LLC</span>
            </div>
            <p className="text-[#A0A0AB] text-xs leading-relaxed">Digital technology and media holding company specializing in app development, health tech, and digital media.</p>
          </div>
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">{t("footer_platform")}</h4>
            <div className="flex flex-col gap-2">
              <Link to="/marketplace" className="text-[#A0A0AB] text-xs hover:text-[#00F0FF] transition-colors">{t("nav_marketplace")}</Link>
              <Link to="/services" className="text-[#A0A0AB] text-xs hover:text-[#00F0FF] transition-colors">{t("nav_services")}</Link>
              <Link to="/creator" className="text-[#A0A0AB] text-xs hover:text-[#00F0FF] transition-colors">{t("footer_become_creator")}</Link>
              <Link to="/nonprofit" className="text-[#A0A0AB] text-xs hover:text-[#00F0FF] transition-colors">{t("footer_nonprofit")}</Link>
            </div>
          </div>
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">{t("footer_company")}</h4>
            <div className="flex flex-col gap-2">
              <a href="#about" className="text-[#A0A0AB] text-xs hover:text-[#00F0FF] transition-colors">{t("nav_about")}</a>
              <a href="#apps" className="text-[#A0A0AB] text-xs hover:text-[#00F0FF] transition-colors">{t("nav_apps")}</a>
              <a href="#contact" className="text-[#A0A0AB] text-xs hover:text-[#00F0FF] transition-colors">{t("nav_contact")}</a>
            </div>
          </div>
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">{t("footer_legal")}</h4>
            <div className="flex flex-col gap-2">
              <Link to="/terms" data-testid="footer-terms" className="text-[#A0A0AB] text-xs hover:text-[#00F0FF] transition-colors">{t("footer_terms")}</Link>
              <Link to="/privacy" data-testid="footer-privacy" className="text-[#A0A0AB] text-xs hover:text-[#00F0FF] transition-colors">{t("footer_privacy")}</Link>
            </div>
          </div>
        </div>
        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-[#A0A0AB] text-xs">&copy; {new Date().getFullYear()} Fortis Digital LLC. {t("footer_rights")}</p>
          <div className="flex gap-4 text-xs">
            <Link to="/terms" className="text-[#A0A0AB] hover:text-[#00F0FF] transition-colors">{t("footer_terms")}</Link>
            <Link to="/privacy" className="text-[#A0A0AB] hover:text-[#00F0FF] transition-colors">{t("footer_privacy")}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
